import React from 'react';

import PropTypes from 'prop-types';

import { ButtonToolbar } from 'reactstrap';

import DeleteItinerarySupplierFoodButton from './resource/DeleteItinerarySupplierFoodButton';

import EditItineraryFoodButton from './EditItineraryFoodButton';

const ItinerarySupplierFoodToolbar = ({ itinerarySupplierFood }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditItineraryFoodButton itinerarySupplierFood={itinerarySupplierFood} />{' '}
      <DeleteItinerarySupplierFoodButton
        itinerarySupplierFoodId={itinerarySupplierFood.id}
      />
    </div>
  </ButtonToolbar>
);

ItinerarySupplierFoodToolbar.propTypes = {
  itinerarySupplierFood: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default ItinerarySupplierFoodToolbar;
